export enum PerfilEnum {
  AnalistaMctic = 'SEPIN - Analista',
  ApoioTecnico = 'SEPIN - Apoio Técnico',
  RepresentanteLegal = 'SEPIN - Representante Legal',
  ResponsavelLegal = 'SEPIN - Responsável Legal',
  ResponsavelTecnicoPleito = 'SEPIN - Responsável Técnico Pleito',
  GestorMctic = 'SEPIN - Gestor MCTIC',
  ResponsavelInstituicao = 'SEPIN - Responsável Instituição',
  ChefeDivisao = 'SEPIN - Chefe de Divisão',
  SubstitutoChefeDivisao = 'Substituto Chefe de Divisão COINDI',
  Coordenador = 'SEPIN - Coordenador',
  SubstitutoCoordenadorCOINDI = 'Substituto Coordenador COINDI',
  CoordenadorG = 'SEPIN - Coordenador Geral',
  SubstitutoCoordenador = 'Substituto Coordenador',
  Diretor = 'SEPIN - Diretor',
}
